/* eslint class-methods-use-this: ["error", { "exceptMethods": ["upload", "onUploadSuccess", "onUploadError"] }] */
// This tells ESLint to ignore the class-methods-use-this rule for the specified methods, acknowledging that they are intended to be overridden and may not use this.
class GenericUploader {
  upload(files) {
    throw new Error(`Method 'upload(${files})' must be implemented.`)
  }

  onUploadSuccess(result) {
    throw new Error(`Method 'onUploadSuccess(${result})' must be implemented.`)
  }

  onUploadError(error) {
    throw new Error(`Method 'onUploadError(${error})' must be implemented.`)
  }
}

export default GenericUploader
